import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content-saved-packages" }
const _hoisted_2 = { class: "content-saved" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content-price" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "spinner spinner-small"
}
const _hoisted_8 = { class: "content-copy" }
const _hoisted_9 = { class: "content-floorplan" }
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "facade-img",
        src: $setup.props.facadePackage.url
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, "Package Price: " + _toDisplayString($setup.calculateBuildPriceOrPackagePriceTotal($setup.props.housePackage.price, $setup.props.facadePackage.price, $setup.props.siteCosts, $setup.props.lotPackage.price)), 1),
        (!$setup.isLoading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button default primary saved",
              disabled: $setup.isLoading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.props.isUpdate ? $setup.onUpdatePackage() : $setup.onSavePackage()))
            }, "Save Changes", 8, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7)),
        _createElementVNode("div", _hoisted_8, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "link" }, "www.lottrackr.com/quote", -1)),
          ($setup.props.isUpdate)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button default copy",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onCopyLinkPackage())),
                type: "button"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("img", {
        class: "floorplan-img",
        src: $setup.props.floorplanPackage.url
      }, null, 8, _hoisted_10)
    ])
  ]))
}